



















































import { Component, Inject, Vue } from "vue-property-decorator";
import { mdiGenderFemale, mdiGenderMale } from "@mdi/js";
import GenderIcon from "./GenderIcon.vue";
import NameStreamGraph from "./NameStreamGraph.vue";
import { DataPoint, HSL, Name } from "../models";
import { paletteGenerator } from "../utils/paletteGenerator";

@Component({
  components: {
    GenderIcon,
    NameStreamGraph
  },
  watch: {
    nameSearchTerm(val: string | null) {
      if (!val) return;
      fetch(`${process.env.VUE_APP_API_ROOT}/names/${val}`)
        .then(res => res.json())
        .then((names: Name[]) => {
          this.$data.searchNames = names;
        });
    },
    selectedNames(val: Name[]) {
      const newName = val.find(
        name =>
          !this.$data.selectedNameData
            .map((record: [Name, DataPoint[]]) => record[0])
            .includes(name)
      );

      if (!newName) return;

      // get data for the new name
      fetch(
        `${process.env.VUE_APP_API_ROOT}/births/${newName.name}/gender/${newName.gender}`
      )
        .then(res => res.json())
        .then((data: DataPoint[]) => {
          this.$data.selectedNameData.push([newName, data]);
        });
    }
  },
  created() {
    fetch(`${process.env.VUE_APP_API_ROOT}/minmax-years`)
      .then(res => res.json())
      .then((data: any) => {
        const { minYear, maxYear } = data;
        this.$data.minYear = minYear;
        this.$data.maxYear = maxYear;
      });
  }
})
export default class NameSearch extends Vue {
  @Inject("primaryColour") private primaryColour!: HSL;

  nameSearchTerm = "";
  selectedNames: Name[] = [];
  searchNames: Name[] = [];
  selectedNameData: [Name, DataPoint[]][] = [];

  minYear = 2010;
  maxYear = 2015;

  femaleIcon = mdiGenderFemale;
  maleIcon = mdiGenderMale;

  get years() {
    const returnArray = [];
    for (let i = this.minYear; i <= this.maxYear; i++) {
      returnArray.push(i);
    }
    return returnArray;
  }

  getColour(i: number) {
    const { hue, saturation, light } = this.primaryColour;
    return paletteGenerator(
      { hue, saturation: saturation - 30, light: light + 20 },
      i
    );
  }

  get autocompleteItems() {
    return [...this.searchNames, ...this.selectedNames];
  }

  get svgWidth() {
    return 300;
  }

  remove(nameToRemove: Name) {
    const { name, gender } = nameToRemove;
    this.selectedNames = this.selectedNames.filter(
      n => n.name !== name || n.gender !== gender
    );

    this.selectedNameData = this.selectedNameData.filter(
      record => record[0] !== nameToRemove
    );
  }
}
